<template>
    <div>
        <limitless-page-header :title="'Produkttyper'"></limitless-page-header>

        <div class="content">
            <rednax-datatable
                :url="'/vue/product_types'"
                :columns="table_columns"
                :filter="table_filter"
                sort-by="id"
                sort-order="asc"
                @updateFilter="table_filter=$event"
                @rowclick="rowClick"
                history
            >
                <div class="row">
                    <div class="col-lg-3">
                        <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                    </div>
                </div>

                <template #cell_name="{ row }">
                    <router-link :to="{ name: 'producttypes.edit', params: { id: row.id } }">{{ row.name }}</router-link>
                </template>
                <template #cell_allowed_shipping_methods="{ row }">
                    <span
                        v-for="method in row.allowed_shipping_methods || []"
                        :key="'method-' + row.id + '-' + method"
                        class="badge badge-light mr-1"
                    >
                        {{ shippingMethodLabel(method) }}
                    </span>
                </template>
            </rednax-datatable>
        </div>
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';

export default {
    name: 'ProductTypeList',
    components: {
        LimitlessPageHeader,
        RednaxDatatable,
    },
    data: () => ({
        table_filter: {
            search: '',
            per_page: 25,
        },
        table_columns: [
            {
                header: '#',
                data: 'id',
                sortable: true,
            },
            {
                header: 'Namn',
                data: 'name',
                sortable: true,
            },
            {
                header: 'Kod',
                data: 'code',
                sortable: true,
            },
            {
                header: 'Fraktsätt',
                data: 'allowed_shipping_methods',
                sortable: false,
            },
        ],
        shipping_method_labels: {
            DPD: 'MyPack Home',
            postoffice: 'MyPack Collect',
            postal: 'Varubrev',
            online: 'Online',
        },
    }),
    methods: {
        rowClick(row, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                const route = this.$router.resolve({ name: 'producttypes.edit', params: { id: row.id } });
                window.open(route.href, '_blank').focus();
            } else {
                this.$router.push({ name: 'producttypes.edit', params: { id: row.id } });
            }
        },
        shippingMethodLabel(method) {
            return this.shipping_method_labels[method] || method;
        },
    },
};
</script>
